export default __webpack_public_path__ + "Mangal Regular.1091785a5208e5cdf08e.ttf";